module.exports = __webpack_public_path__ + "img/D0015.b0da6fba.svg";